module.exports = __webpack_public_path__ + "img/share.afa2ff65.svg";